import React from 'react';
import './footer.scss';

const Footer = props => {
  return (
    <footer className="footer">
      <p>© 2019 RSS Group 20</p>
    </footer>
  );
};

export default Footer;
